import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-authenticators', {
        url: '/shared-authenticators',
        component: 'companySharingCenterSharedAuthenticators',
        resolve: {accounts},
    });
}

/** @ngInject */
function accounts($filter, companyId, SharedAccountsService) {
    return SharedAccountsService
        .getAllByCompany({companyId}, {}).$promise
        .then(items => items.filter(item => item.enabled2fa))
        .then(items => $filter('orderBy')(items, 'publicService.serviceName'))
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/shared-authenticators.state.js